import { Grid as MuiGrid } from "@mui/material";
import React from "react";

export default function GridItem({ children, ...rest }) {
  return (
    <MuiGrid item {...rest}>
      {children}
    </MuiGrid>
  );
}
